import type { ServerBillingStatus, ServerMembership } from '@oracord/shared';

type Role = ServerMembership['role'];

export function billingAllowsAppAccess(billing: ServerBillingStatus | null): boolean {
  return Boolean(billing?.active);
}

export function isBillingRoute(pathname: string): boolean {
  return pathname === '/billing' || pathname.startsWith('/billing/');
}

export function shouldRedirectToBilling({
  pathname,
  search = '',
  role,
  billing,
}: {
  pathname: string;
  search?: string;
  role: Role;
  billing: ServerBillingStatus | null;
}): boolean {
  if (role !== 'owner' && role !== 'admin') return false;
  if (isBillingRoute(pathname)) return false;
  if (pathname === '/setup' && new URLSearchParams(search).get('billing') === 'success') return false;
  return !billingAllowsAppAccess(billing);
}

export function shouldWaitForActiveOrganizationRepair({
  activeOrgId,
  resolvedOrgId,
}: {
  activeOrgId: string | null;
  resolvedOrgId: string;
}): boolean {
  return activeOrgId !== resolvedOrgId;
}

export function defaultSignedInHomePath({
  role,
  billing,
  hasConnectedSource,
}: {
  role: Role;
  billing: ServerBillingStatus | null;
  hasConnectedSource: boolean;
}): '/billing' | '/setup' | '/staff/setup' {
  if (role === 'member') return '/staff/setup';
  void hasConnectedSource;
  return billingAllowsAppAccess(billing) ? '/setup' : '/billing';
}
